import React from 'react';
import { Box, Typography, Button, Paper, Grid, useTheme, alpha } from '@mui/material';
import SectionContainer from './SectionContainer';
import AnimatedElement from './AnimatedElement';
import TelegramIcon from '@mui/icons-material/Telegram';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const FeatureCheck = ({ text }) => {
  const theme = useTheme();
  
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      <CheckCircleOutlineIcon sx={{ color: theme.palette.secondary.main, mr: 2 }} />
      <Typography variant="body1">{text}</Typography>
    </Box>
  );
};

const CtaSection = () => {
  const theme = useTheme();
  
  return (
    <SectionContainer
      id="cta"
      bgColor={`linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.secondary.main, 0.05)} 100%)`}
      py={12}
    >
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12} md={10} lg={8}>
          <AnimatedElement animation="fadeIn">
            <Paper
              elevation={0}
              sx={{
                borderRadius: 4,
                overflow: 'hidden',
                p: { xs: 3, md: 6 },
                position: 'relative',
                bgcolor: 'background.paper',
                boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '8px',
                  background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                }
              }}
            >
              <Grid container spacing={4} alignItems="center">
                <Grid item xs={12} md={7}>
                  <AnimatedElement animation="fadeInLeft" delay={0.2}>
                    <Typography
                      variant="h3"
                      component="h2"
                      gutterBottom
                      sx={{
                        fontWeight: 'bold',
                        fontSize: { xs: '2rem', md: '2.5rem' },
                      }}
                    >
                      Начните проводить вебинары в Telegram уже сегодня
                    </Typography>
                    
                    <Typography variant="h6" sx={{ mb: 4, color: 'text.secondary' }}>
                      Увеличьте конверсию ваших вебинаров и получите доступ к реальным контактам участников
                    </Typography>
                    
                    <Box sx={{ mb: 4 }}>
                      <FeatureCheck text="14 дней бесплатного пробного периода" />
                      <FeatureCheck text="Без ограничений функционала в пробный период" />
                      <FeatureCheck text="Без привязки банковской карты" />
                      <FeatureCheck text="Поддержка на всех этапах внедрения" />
                    </Box>
                    
                    <Button
                      variant="contained"
                      color="secondary"
                      size="large"
                      startIcon={<TelegramIcon />}
                      href="https://t.me/webigramhost_bot"
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        px: 4,
                        py: 1.5,
                        borderRadius: 2,
                        fontSize: '1.1rem',
                        boxShadow: '0 8px 20px rgba(255, 64, 129, 0.3)',
                      }}
                    >
                      Начать бесплатно
                    </Button>
                  </AnimatedElement>
                </Grid>
                
                <Grid item xs={12} md={5}>
                  <AnimatedElement animation="fadeInRight" delay={0.4}>
                    <Box
                      sx={{
                        backgroundColor: alpha(theme.palette.primary.main, 0.05),
                        borderRadius: 4,
                        p: 3,
                        border: `1px dashed ${alpha(theme.palette.primary.main, 0.2)}`,
                      }}
                    >
                      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                        Тарифные планы
                      </Typography>
                      
                      <Box sx={{ mb: 2, mt: 3 }}>
                        <Typography variant="h6" fontWeight="bold">
                          Стартовый
                        </Typography>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                          Для тех, кто только начинает
                        </Typography>
                        <Typography variant="h4" fontWeight="bold" color="primary.main" gutterBottom>
                          2 900 ₽<Typography component="span" variant="body2" sx={{ ml: 1 }}>/месяц</Typography>
                        </Typography>
                        <Typography variant="body2">
                          До 100 участников, 5 вебинаров в месяц
                        </Typography>
                      </Box>
                      
                      <Box sx={{ mb: 2, pt: 2, borderTop: `1px solid ${alpha(theme.palette.primary.main, 0.1)}` }}>
                        <Typography variant="h6" fontWeight="bold">
                          Профессиональный
                        </Typography>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                          Для активных пользователей
                        </Typography>
                        <Typography variant="h4" fontWeight="bold" color="primary.main" gutterBottom>
                          5 900 ₽<Typography component="span" variant="body2" sx={{ ml: 1 }}>/месяц</Typography>
                        </Typography>
                        <Typography variant="body2">
                          До 500 участников, неограниченное количество вебинаров
                        </Typography>
                      </Box>
                      
                      <Button
                        variant="outlined"
                        color="primary"
                        fullWidth
                        sx={{ mt: 2 }}
                      >
                        Подробнее о тарифах
                      </Button>
                    </Box>
                  </AnimatedElement>
                </Grid>
              </Grid>
            </Paper>
          </AnimatedElement>
        </Grid>
      </Grid>
    </SectionContainer>
  );
};

export default CtaSection; 